import { html, LitElement } from 'lit-element';
import { Measurements } from '~/utility/measurements';
import { sharedStyles } from '../styles/shared-styles';

class BnDimension extends LitElement {
  constructor() {
    super();
    this.measurement = Measurements.get('dimension');
    this.precision = 2;
  }

  static get styles() {
    return sharedStyles;
  }

  static get properties() {
    return {
      value: { type: Number },
      precision: { type: Number },
    };
  }

  render() {
    const unit = this.measurement.unit;
    const val = this.measurement.convert({ dimension: this.value });

    if (isNaN(val)) {
      return html`- <span class="unit">${unit}</span>`;
    }

    const formatter = new Intl.NumberFormat();
    const fmt = n => formatter.format(n);

    // if unit is inches, convert to feet and inches
    if (unit === 'in') {
      const feet = Math.floor(val / 12);
      const inches = Number((val % 12).toFixed(this.precision));
      if (feet > 0) {
        return html`${fmt(feet)} <span class="unit">ft</span> ${fmt(inches)} <span class="unit">in</span>`;
      }
    }

    return html`${fmt(val)} <span class="unit">${unit}</span>`;
  }
}

window.customElements.define('bn-dimension', BnDimension);
